import  { useState, useEffect } from "react";
import ExcelJS from "exceljs";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  ListItemText,
  ListItemIcon,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  IconButton,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useAuth } from "../../../AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import Swal from "sweetalert2";
import { GlobalStyles } from "@mui/system";
import dayjs from "dayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


const AllExaminationScheduleList = ({ initialRows }) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
  const navigate = useNavigate();
  const { userId,pId,oId,board,role} = useAuth();
  // const UserId = userId ;

  const [filteredData, setFilteredData] = useState([]);
  const [selectedExamType, setSelectedExamType] = useState("");
  const [loading, setLoading] = useState(false); // To handle button state
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl); // Now it's used after declaration

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  // State for tracking selected row for editing
  const [selectedRow, setSelectedRow] = useState(null);
  const [examTypeOptions, setExamTypeOptions] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");
  
  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  // const [interSelectedClass, setInterSelectedClass] = useState("");
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
  // const [interSelectedSection, setInterSelectedSection] = useState("Section-A");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");
 

  const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
 
  const [sscClassSectionMap, setSscClassSectionMap] = useState({});

  const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};


  const handleExportClose = () => {
    setExportAnchorEl(null);
  };


  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
 


 
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/EXAMINATION_CELL/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount 

const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};

// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if (!UserId || !sscSelectedClass || !sscSelectedSection || !selectedExamType) {
    setFilteredData([]);

    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/examCell/getClassAndSectionWithExamType/${oId}/${pId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&examType=${selectedExamType}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      if (!selectedCourseType) {
        setSelectedCourseType(data[0] || "");
      }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection || !selectedExamType) {
    setFilteredData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/examCell/getClassAndSectionWithExamType/${oId}/${pId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&examType=${selectedExamType}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
     
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here







// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);

// Fetch Table Data whenever filters change
useEffect(() => {
  if (board === "SSC") {
    if (!sscSelectedClass || !sscSelectedSection) {
   
      setFilteredData([]);
      setLoading(false); // ✅ stop loading even if API not called
      return;
    }
    fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
  } else if (board === "INTERMEDIATE") {
    if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
    
      setFilteredData([]);
      
      setLoading(false); // ✅ same here
      return;
    }
    fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
  }
}, [UserId,board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType,selectedExamType]);


const fetchSubjectOptions = async ({
  mode = "default", // 'default' or 'edit'
} = {}) => {
  try {
    if (!oId || !pId) {
      setSubjectOptions([]);
      return;
    }

    if (board === "SSC") {
      if (!selectedRow || !selectedRow.romanNumberClass) {
        setSubjectOptions([]);
        return;
      }
    } else if (board === "INTERMEDIATE") {
      if (!interSelectedClass || !selectedCourseType) {
        setSubjectOptions([]);
        return;
      }
    } else {
      setSubjectOptions([]);
      return;
    }

    let url = "";
    if (board === "SSC") {
      url = `${baseUrl}/api/dynamic-classReg/getAllSubjects/by-class/${pId}?classRegistration=${selectedRow.romanNumberClass}`;
    } else if (board === "INTERMEDIATE") {
      url = `${baseUrl}/api/dynamic-classReg/getAllSubjectsIntermediate/by-class/${pId}?classRegistration=${interSelectedClass}&course=${selectedCourseType}`;
    }

    const response = await fetch(url);
    const data = await response.json();

    if (response.ok && Array.isArray(data) && typeof data[0] === "string") {
      const subjectsArray = data[0].split(",").map((name, idx) => ({
        id: idx + 1,
        name: name.trim(),
      }));
      setSubjectOptions(subjectsArray);
    } else {
      setSubjectOptions([]);
    }

    if (mode === "edit") {
     
    }
  } catch (err) {
    console.error(`Error fetching subject options (${mode}):`, err);
    setSubjectOptions([]);
  }
};
useEffect(() => {
  fetchSubjectOptions();
}, [board, oId, pId, selectedRow, interSelectedClass, selectedCourseType]);




useEffect(() => {
  if (isEditModalOpen && selectedRow) {
    fetchSubjectOptions({
      className: selectedRow.romanNumberClass,
      course: selectedRow.course,
      mode: "edit",
    });
  }
}, [isEditModalOpen, selectedRow]);






// //EXAM TYPE OPTIONS
useEffect(() => {
  const fetchExamTypeOptions = async () => {
    /* ── Guard clauses ─────────────────────────────── */
    if (!board || !pId) {
      setExamTypeOptions([]);
      setSelectedExamType("");
      return;                       // missing essentials
    }

    if (board === "SSC") {
      if (!sscSelectedClass) {
        setExamTypeOptions([]);
        setSelectedExamType("");
        return;                     // SSC needs class
      }
    } else if (board === "INTERMEDIATE") {
      if (!interSelectedClass || !selectedCourseType) {
        setExamTypeOptions([]);
        setSelectedExamType("");
        return;                     // Intermediate needs both
      }
    } else {
      setExamTypeOptions([]);       // unknown board
      setSelectedExamType("");
      return;
    }

    /* ── Build URL ─────────────────────────────────── */
    const url =
      board === "SSC"
        ? `${baseUrl}/api/dynamic-classReg/getAllExamsType/by-class/${pId}?classRegistration=${sscSelectedClass}`
        : `${baseUrl}/api/dynamic-classReg/getAllExamsType/by-class/${pId}?course=${selectedCourseType}&classRegistration=${interSelectedClass}`;

    /* ── Fetch ─────────────────────────────────────── */
    try {
      const response = await fetch(url);
      const data = await response.json();

      if (response.ok) {
        const uniqueTypes = [
          ...new Set(
            data
              .flatMap((entry) => entry.split(","))
              .map((t) => t.trim())
          ),
        ];
        setExamTypeOptions(uniqueTypes);
        setSelectedExamType(uniqueTypes[0] || "");
      } else {
        setExamTypeOptions([]);
        setSelectedExamType("");
      }
    } catch (err) {
      console.error("Error fetching exam types:", err);
      setExamTypeOptions([]);
      setSelectedExamType("");
    }
  };

  fetchExamTypeOptions();
}, [board, pId, sscSelectedClass, interSelectedClass, selectedCourseType]);





 
  
  const handleEditRow = (row) => {
    setSelectedRow(row); // Store the selected row data in state
    setIsEditModalOpen(true); // Open the edit modal
  };

  // ✅ Call fetchData after successful update
  const handleSaveChanges = async () => {
    if (!selectedRow || !selectedRow.examId) {
      toast.error("Invalid data. Please select a valid row.");
      return;
    }


    setLoading(true);

    try {
      // 🔹 Create FormData object
      const formData = new FormData();
      Object.keys(selectedRow).forEach((key) => {
        formData.append(key, selectedRow[key]);
      });

      const response = await fetch(
        `${baseUrl}/api/examCell/update/${selectedRow.examId}/${oId}`,
        {
          method: "PATCH",
          body: formData, // 🔹 Send FormData
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error ${response.status}: ${errorText}`);
      }

      let responseData;
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        responseData = await response.json();
       
      } else {
        responseData = await response.text();
        console.warn("Non-JSON response:", responseData);
      }

      toast.success("Updated Successfully!", {
        position: "top-right",
        autoClose: 1000, // Toast shows for 1 second
      });

  fetchClassSectionTableData();

      // ✅ Close the dialog
      handleDialogClose();

      // ✅ Fetch updated data
      if(board === "INTERMEDIATE"){
        fetchCourseClassSectionTableData();
      }else{
        fetchClassSectionTableData();
      }
    } catch (error) {
      console.error("Error updating details:", error);
      toast.error(`Error updating details: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };


  const handleDeleteClick = async (row) => {
    if (!row || !row.examId) {
      toast.error("Invalid row. Please select a valid row to delete.");
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: `want to delete this ${row.subject} exam `, // ✅ Dynamically include subject name
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
         

          const response = await fetch(
            `${baseUrl}/api/examCell/delete/${row.examId}/${oId}`,
            { method: "DELETE" }
          );

          if (!response.ok) {
            throw new Error("Failed to delete the row. Please try again.");
          }

          toast.success(`Subject "${row.subject}" deleted successfully!`, { autoClose: 1000 });

            fetchClassSectionTableData();
         
        } catch (error) {
          console.error("Error deleting row:", error);
          toast.error(`Error deleting row: ${error.message}`);
        }
      }
    });
  };

  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };


  const exportToExcel = () => {
    const isIntermediate = board === "INTERMEDIATE";
    const dynamicKey = isIntermediate ? "Year" : "Class";

    const processedData = filteredData.map(
      (
        { examDate,course, romanNumberClass, sections, subject,examType, examTime,examTimeEnd },
        index
      ) => ({
        SNo: index + 1,
        examDate: examDate,
        ...(isIntermediate ? { Course: course } : {}),
        [dynamicKey]: romanNumberClass,
        Section: sections,
        Subject: subject,
        ExamType: examType,
        ExamTime: `${examTime}-${examTimeEnd}`  ,
      })
    );

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      board === "INTERMEDIATE"
        ? `${interSelectedClass}-${interSelectedSection}_ScheduleList`
        : `${sscSelectedClass}-${sscSelectedSection}_ScheduleList`
    );

    // Add headers
    worksheet.columns = [
      { header: "S.No", key: "SNo", width: 10 }, // Keep S.No as the first column
      { header: "Date", key: "examDate", width: 15 },
      ...(board === "INTERMEDIATE"
        ? [{ header: "Course", key: "Course", width: 15 }]
        : []),
        { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
      { header: "Section", key: "Section", width: 20 },
      { header: "Subject", key: "Subject", width: 30 },
      { header: "Exam Type", key: "ExamType", width: 40 },
      { header: "Exam Time", key: "ExamTime", width: 40 },
      // { header: "Subject", key: "Subject", width: 40 },
    ];

    // Add data to worksheet
    processedData.forEach((data) => {
      worksheet.addRow(data);
    });

    // Style headers
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "87CEEB" }, // Light Blue Header
      };
    });

   

    // Write and download file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
       // Generate dynamic filename
    link.download = board === "INTERMEDIATE"
    ? `${interSelectedClass}-${interSelectedSection}_ScheduleList.xlsx`
    : `${sscSelectedClass}-${sscSelectedSection}_ScheduleList.xlsx`;
      link.click();
    });

    handleExportClose();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
  
    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
  
    const title =
      board === "INTERMEDIATE"
        ? `${interSelectedClass}-${interSelectedSection} ScheduleList`
        : `${sscSelectedClass}-${sscSelectedSection} ScheduleList`;
  
    doc.text(title, 10, 8);
  
    // Define table headers dynamically
    const headers =
      board === "INTERMEDIATE"
        ? [
            "S.No",
            "Date",
            "Course",
            "Year",
            "Section",
            "Subject",
            "Exam Type",
            "Exam Time",
          ]
        : [
            "S.No",
            "Date",
            "Class",
            "Section",
            "Subject",
            "Exam Type",
            "Exam Time",
          ];
  
    // Define table body data
    const bodyData = filteredData.map((row, index) => {
      const rowData = [
        index + 1,
        row.examDate,
      ];
  
      if (board === "INTERMEDIATE") {
        rowData.push(row.course); // Add course only for INTERMEDIATE
      }
  
      rowData.push(
        row.romanNumberClass,
        row.sections,
        row.subject,
        row.examType,
        `${row.examTime}-${row.examTimeEnd}`
      );
  
      return rowData;
    });
  
    // Table rendering
    doc.autoTable({
      startY: 20,
      head: [headers],
      body: bodyData,
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181],
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      theme: "grid",
    });
  
    // Filename
    const fileName =
      board === "INTERMEDIATE"
        ? `${interSelectedClass}-${interSelectedSection}_ScheduleList.pdf`
        : `${sscSelectedClass}-${sscSelectedSection}_ScheduleList.pdf`;
  
    doc.save(fileName);
    handleExportClose();
  };
  
 







  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
              <IconButton
                onClick={() => navigate("/ExaminationDashboard")}
                sx={{ color: "#2e2a54" }}
              >
                <KeyboardBackspaceIcon fontSize="medium" />
              </IconButton>
              <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                Examination Schedule
              </Typography>
            </Box>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Box display="flex" mb={3} flexWrap="wrap">
                {/* Select Class */}



{board === "SSC" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="class-select-label">Select Class</InputLabel>
      <Select
        labelId="class-select-label"
        value={sscSelectedClass}
       

        onChange={(e) => {
          const selected = e.target.value;
          setSscSelectedClass(selected);
          // setMode("classSection");
      
          const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
          setSscSectionOptions(sections);
          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
        }}
        
        label="Select Class"
        sx={{ height: 35 }}
      >
        {sscClassOptions.map((cls) => (
          <MenuItem key={cls} value={cls}>{cls}</MenuItem>
        ))}
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120 ,marginRight:2}}>
  <InputLabel id="section-select-label">Select Section</InputLabel>
  <Select
    labelId="section-select-label"
    value={sscSelectedSection}
    onChange={(e) => {
      setSscSelectedSection(e.target.value);
      // setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {/* Show placeholder if no sections */}
    {sscSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Class
      </MenuItem>
    ) : (
      sscSectionOptions.map((section) => (
        <MenuItem key={section} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>

  </>
)}


{board === "INTERMEDIATE" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        value={interSelectedClass}
        onChange={(e) => setInterSelectedClass(e.target.value)}
        label="Select Year"
        sx={{ height: 35 }}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="course-type-label">Select Course</InputLabel>
      <Select
        labelId="course-type-label"
        value={selectedCourseType}
        // onChange={(e) => setSelectedCourseType(e.target.value)}
        onChange={(e) => {
          setSelectedCourseType(e.target.value);
          // setMode("classSection");
        }}
        
        label="Select Course"
        sx={{ height: 35 }}
      >
        {courseOptions.map((course, index) => (
          <MenuItem key={index} value={course}>{course}</MenuItem>
        ))}
      </Select>
    </FormControl>

  
    <FormControl size="small" sx={{ minWidth: 120 ,marginRight:2}}>
  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
  <Select
    labelId="intermediate-section-select-label"
    value={interSelectedSection || ""}
    onChange={(e) => {
      setInterSelectedSection(e.target.value);
      // setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {interSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Year and Course
      </MenuItem>
    ) : (
      interSectionOptions.map((section, index) => (
        <MenuItem key={index} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>

  </>
)}
         

                {/* Exam Type */}
                <FormControl sx={{ width: 140, ml: 1 }} size="small">
                  <InputLabel>Exam Type</InputLabel>
                  <Select
                    value={selectedExamType}
                    onChange={(e) => setSelectedExamType(e.target.value)}
                    label="Exam Type"
                  >
                   
                    {examTypeOptions.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* <Box sx={{ flexGrow: 1 }} /> */}
              </Box>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "5px",
              }}
            >
              <div>
                <Button
                  variant="contained"
                  onClick={handleExportClick}
                  sx={{
                    backgroundColor: "#3C3972",
                    color: "white",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#3C3972",
                    },
                  }}
                  startIcon={<PresentToAllIcon />}
                >
                  Export
                </Button>

                <Menu
                  anchorEl={exportAnchorEl}
                  open={isExportMenuOpen}
                  onClose={handleExportClose}
                  sx={{
                    "& .MuiPaper-root": {
                      backgroundColor: "#f5f5f5",
                      borderRadius: "8px",
                    },
                  }}
                >
                  <MenuItem
                    onClick={exportToExcel}
                    // onClick={downloadExcel}
                    sx={{
                      color: "#3f51b5",
                      fontWeight: "bold",
                      "&:hover": {
                        backgroundColor: "#e8f0fe",
                      },
                    }}
                  >
                    <ListItemIcon sx={{ color: "#00796b" }}>
                      <SimCardDownloadIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Excel"
                      sx={{ fontWeight: "bold", color: "#00796b" }}
                    />
                  </MenuItem>

                  <MenuItem
                    onClick={exportToPDF}
                    sx={{
                      color: "#d32f2f",
                      fontWeight: "bold",
                      "&:hover": {
                        backgroundColor: "#fdecea",
                      },
                    }}
                  >
                    <ListItemIcon sx={{ color: "#d32f2f" }}>
                      <PictureAsPdfIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="PDF"
                      sx={{ fontWeight: "bold", color: "#d32f2f" }}
                    />
                  </MenuItem>

                
                </Menu>
              </div>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#3C3972",
                  width: "150px",
                  height: "32px",
                  color: "white",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#3C3972",
                  },
                }}
                onClick={() => navigate("/AllExaminationScheduleForm")}
              >
                Schedule New Exam
              </Button>
            </div>
          </div>

          <GlobalStyles
                            styles={{
                              '.custom-sidebar-scrollbar': {
                                scrollbarWidth: 'thin', // For Firefox
                                scrollbarColor: 'grey #e0e0e0',
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                                width: '6px', // For WebKit-based browsers
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                                background: '#f1f1f1', // Track color
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                                backgroundColor: 'grey', // Thumb color
                                borderRadius: '10px',
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                                backgroundColor: '#555',
                              },
                            }}
                          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "69vh",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    S.No
                  </TableCell>
                 

                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Date
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Exam Time
                  </TableCell>
                  {(board === "INTERMEDIATE" ) && (
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Course
                  </TableCell>
                  )}
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    {board === "INTERMEDIATE" ? "Year" : "Class"}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Section
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Exam Type
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Subject
                  </TableCell>
                  
                  
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow>
                    {/* <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      <CircularProgress size={20} />
                    </TableCell> */}

                    <TableCell
                      colSpan={12}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredData.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredData.map((row, index) => (
                    <TableRow
                      key={row.admissionNumber}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        {formatDate(row.examDate)}
                      </TableCell>
                      <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "4px",
                            textAlign: "center",
                          }}
                        >
                          {row.examTime && row.examTimeEnd
                              ? `${row.examTime} - ${row.examTimeEnd}`
                              : ""}
                        </TableCell>
                        {board === "INTERMEDIATE" && (
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.course}
                      </TableCell>
                      )}


                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.romanNumberClass}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.sections}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.examType}
                      </TableCell>


                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        {row.subject}
                      </TableCell>
                     
                      <TableCell
                        sx={{
                          width: "10rem",
                          textAlign: "center",
                          padding: "2px",
                        }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          sx={{
                            color: "white",
                            textTransform: "none",
                            minWidth: "60px",
                            padding: "2px 6px",
                            fontSize: "12px",
                            height: "24px", // Reduced height
                            lineHeight: "1",
                            margin: "4px 4px 4px 0", // Added top & bottom margin
                            backgroundColor: "#1976d2", // Darker than #90caf9
                            "&:hover": { backgroundColor: "#1565c0" }, // Darker than #64b5f6
                          }}
                          // onClick={() => handleEditClick(row)}
                          onClick={() => handleEditRow(row)} 
                        >
                          Edit
                        </Button>

                       

                        <Button
                          variant="contained"
                          size="small"
                          sx={{
                            color: "white",
                            textTransform: "none",
                            minWidth: "60px",
                            padding: "2px 6px",
                            fontSize: "12px",
                            height: "24px",
                            lineHeight: "1",
                            margin: "4px 4px 4px 0",
                            backgroundColor: "#d32f2f",
                            "&:hover": { backgroundColor: "#b71c1c" },
                          }}
                          onClick={() => {
                            
                            if (row.examId) {
                              handleDeleteClick(row); // ✅ Pass entire row object
                            } else {
                              console.error("row.examId is undefined");
                            }
                          }}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>

          {/* Dialog for editing */}
          {isEditModalOpen && selectedRow && (
  <Dialog
    open={isEditModalOpen}
    onClose={() => setIsEditModalOpen(false)}
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle sx={{ fontWeight: "bold" }}>Edit Details</DialogTitle>
    <DialogContent>
      <Grid container spacing={2}>
        {/* Class Name */}
        <Grid item xs={6}>
          <TextField
            label={board === "INTERMEDIATE" ? "Year" : "Class"}
            value={selectedRow?.romanNumberClass || ""}
            fullWidth
            margin="normal"
            size="small"
            disabled
            InputProps={{
              style: {
                backgroundColor: "#f0f0f0",
                color: "#6c757d",
                fontWeight: "bold",
              },
            }}
          />
        </Grid>

        {/* Course (for INTERMEDIATE) */}
        {board === "INTERMEDIATE" && (
          <Grid item xs={6}>
            <TextField
              label="Course"
              value={selectedRow?.course || ""}
              fullWidth
              margin="normal"
              size="small"
              disabled
              InputProps={{
                style: {
                  backgroundColor: "#f0f0f0",
                  color: "#6c757d",
                  fontWeight: "bold",
                },
              }}
            />
          </Grid>
        )}

        {/* Section */}
        <Grid item xs={6}>
          <TextField
            label="Section"
            value={selectedRow?.sections || ""}
            fullWidth
            margin="normal"
            size="small"
            disabled
            InputProps={{
              style: {
                backgroundColor: "#f0f0f0",
                color: "#6c757d",
                fontWeight: "bold",
              },
            }}
          />
        </Grid>

        {/* Exam Date */}
        <Grid item xs={6}>
          <TextField
            label="Date"
            type="date"
            value={selectedRow?.examDate || ""}
            onChange={(e) =>
              setSelectedRow((prev) => ({
                ...prev,
                examDate: e.target.value,
              }))
            }
            fullWidth
            margin="normal"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {/* Exam Time as Dropdown */}
        <Grid item xs={6}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <TimePicker
      label="Exam Time"
      value={
        selectedRow?.examTime
          ? dayjs(selectedRow.examTime, "hh:mm A")
          : null
      }
      onChange={(newValue) => {
        setSelectedRow((prev) => ({
          ...prev,
          examTime: newValue ? newValue.format("hh:mm A") : "",
        }));
      }}
      ampm
      sx={{ width: "100%" }}
      slotProps={{
        textField: {
          fullWidth: true,
          size: "small",
          sx: {
            mb: 1,
            mt: board === "SSC" ? 2 : 0,  // ← Add margin top only for SSC
          },
        },
      }}
    />
  </LocalizationProvider>
</Grid>

<Grid item xs={6}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <TimePicker
      label="Exam Time End"
      value={
        selectedRow?.examTimeEnd
          ? dayjs(selectedRow.examTimeEnd, "hh:mm A")
          : null
      }
      onChange={(newValue) => {
        setSelectedRow((prev) => ({
          ...prev,
          examTimeEnd: newValue ? newValue.format("hh:mm A") : "",
        }));
      }}
      ampm
      sx={{ width: "100%" }}
      slotProps={{
        textField: {
          fullWidth: true,
          size: "small",
          sx: {
            mb: 1,
            mt: board === "SSC" ? 2 : 0, // ← Match styling with examTime
          },
        },
      }}
    />
  </LocalizationProvider>
</Grid>


        {/* Subject as Dropdown */}
       <Grid item xs={6}>
  <FormControl fullWidth size="small" sx={{ mt: board === "SSC" ? 2 : 0 }}>
    <InputLabel>Select Subject</InputLabel>
    <Select
      value={selectedRow?.subject || ""}
      onChange={(e) =>
        setSelectedRow({ ...selectedRow, subject: e.target.value })
      }
      label="Select Subject"
    >
      {subjectOptions.map((subject) => (
        <MenuItem key={subject.id} value={subject.name}>
          {subject.name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>



      </Grid>
    </DialogContent>

    <DialogActions sx={{ padding: "16px" }}>
      <Button
        onClick={() => setIsEditModalOpen(false)}
        color="primary"
        variant="outlined"
        sx={{
          borderRadius: "8px",
          textTransform: "none",
          padding: "8px 16px",
          fontWeight: 600,
          borderColor: "#1976d2",
          "&:hover": { backgroundColor: "#e3f2fd" },
        }}
      >
        Cancel
      </Button>

      <Button
        onClick={() => {
          if (!selectedRow || !selectedRow.examId) {
            toast.error("Please select a valid row before saving.");
            return;
          }
          handleSaveChanges();
        }}
        color="primary"
        variant="contained"
        sx={{
          borderRadius: "8px",
          textTransform: "none",
          padding: "8px 16px",
          fontWeight: 600,
          backgroundColor: "#3C3972",
          "&:hover": { backgroundColor: "#3C3972" },
        }}
        disabled={loading}
      >
        {loading ? "Saving..." : "Save"}
      </Button>
    </DialogActions>
  </Dialog>
)}


        </CardContent>
        <ToastContainer position="top-right" autoClose={2000} />
      </Card>
    </Box>
  );
};

export default AllExaminationScheduleList;